export default __webpack_public_path__ + "static/media/dtsd5168-5.c8ddb5b5.png";